// extracted by mini-css-extract-plugin
export default {"widgetCardsWrapper":"widgetCardsWrapper_widgetCardsWrapper__bGwYq"};